import { designTokens } from '../tokens';

export type PageContentWidth = 'compact' | 'standard' | 'wide' | 'fluid';

const contentWidths: Record<PageContentWidth, number | 'none'> = {
  compact: designTokens.layout.pageContentCompactWidth,
  standard: designTokens.layout.pageContentStandardWidth,
  wide: designTokens.layout.pageContentMaxWidth,
  fluid: 'none',
};

export const pageGutter = {
  xs: `${designTokens.layout.pageGutterCompact}px`,
  md: `${designTokens.layout.pageGutter}px`,
} as const;

export function pageContentContainer(width: PageContentWidth) {
  return {
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    maxWidth: contentWidths[width],
    mx: 'auto',
  } as const;
}

export function pageContentFrame(width: PageContentWidth) {
  return { ...pageContentContainer(width), px: pageGutter } as const;
}
